
import React, { FC } from 'react';

const ArrowMoveTopIcon: FC = () => (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.65556 12.5714L6.65556 2.62163L10.0389 5.24503C10.2808 5.43261 10.665 5.43261 10.9069 5.24502C11.0311 5.14872 11.1 5.01628 11.1 4.87697C11.1 4.73766 11.0311 4.60522 10.9069 4.50892L6.52867 1.11409C6.40489 0.980019 6.20566 0.899999 6 0.899999C5.79434 0.899999 5.59511 0.980019 5.47133 1.11409L1.09312 4.50892C0.968922 4.60522 0.900001 4.73766 0.9 4.87697C0.899999 5.01628 0.968918 5.14872 1.09311 5.24502C1.33503 5.43261 1.71922 5.43261 1.96114 5.24503L5.34444 2.62163L5.34445 12.5714C5.34445 12.8859 5.66363 13.1 6 13.1C6.33637 13.1 6.65556 12.8859 6.65556 12.5714Z" fill="#FEFEFE" stroke="#FEFEFE" strokeWidth="0.2"/>
    </svg>
);

export default ArrowMoveTopIcon;

import React, { FC } from 'react';

const ArrowMoveTopIcon: FC = () => (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.65556 12.5714L6.65556 2.62163L10.0389 5.24503C10.2808 5.43261 10.665 5.43261 10.9069 5.24502C11.0311 5.14872 11.1 5.01628 11.1 4.87697C11.1 4.73766 11.0311 4.60522 10.9069 4.50892L6.52867 1.11409C6.40489 0.980019 6.20566 0.899999 6 0.899999C5.79434 0.899999 5.59511 0.980019 5.47133 1.11409L1.09312 4.50892C0.968922 4.60522 0.900001 4.73766 0.9 4.87697C0.899999 5.01628 0.968918 5.14872 1.09311 5.24502C1.33503 5.43261 1.71922 5.43261 1.96114 5.24503L5.34444 2.62163L5.34445 12.5714C5.34445 12.8859 5.66363 13.1 6 13.1C6.33637 13.1 6.65556 12.8859 6.65556 12.5714Z" fill="#FEFEFE" stroke="#FEFEFE" strokeWidth="0.2"/>
    </svg>
);

export default ArrowMoveTopIcon;
